<template>
  <div>
    <v-toolbar dense color="grey lighten-2" tabs>
      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <div v-show="showSearch">
        <slot></slot>
      </div>
      
      <v-tooltip bottom>
        <v-btn flat icon small slot="activator" @click="showSearch = !showSearch">
          <v-icon>{{ iconSearch }}</v-icon>
        </v-btn>
        <span>Pesquisar</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn flat icon small slot="activator" @click="$emit('refreshCliente', cliente.IdCliente)">
          <v-icon>refresh</v-icon>
        </v-btn>
        <span>Atualizar</span>
      </v-tooltip>
    </v-toolbar>
    <v-card v-if="cliente">
      <v-card-text>
        <v-layout :column="$vuetify.breakpoint.smAndDown">
          <v-flex xs12 md4>
            <p class="mb-1 cursor-pointer" @click="infoClient(cliente)">
              <span class="font-weight-bold">Empresa:</span>
              {{ cliente.RazaoSocial }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Fantasia:</span>
              {{ cliente.Fantasia }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">CPF/CNPJ:</span>
              {{ cliente.CpfCnpj }}
            </p>
          </v-flex>
          <v-flex xs12 md4>
            <p class="mb-1">
              <span class="font-weight-bold">Situação:</span>
              <v-chip small dark :color="corStatusCliente(cliente.Status)">{{ statusCliente(cliente.Status) }}</v-chip>
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Telefone:</span>
              {{ cliente.Telefone }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Contato:</span>
              {{ cliente.Contato }}
            </p>
          </v-flex>
          <v-flex xs12 md4>
            <p class="mb-1">
              <span class="font-weight-bold">Observações:</span><br>
              <span class="prewrap">{{ cliente.Observacoes }}</span>
            </p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- Modal Cliente -->
    <ModalCadastroCliente 
      v-model="modalCliente"
      :cliente="clienteInfo"
      :clienteEndereco="clienteEndereco"
      :clienteTelefone="clienteTelefone"
      :clienteEmail="clienteEmail"
      @clienteAdicionado="clienteAdicionado"
      @telefoneAdicionado="telefoneAdicionado"
      @emailAdicionado="emailAdicionado"
      @editaTelefone="editaTelefone"
      @editaEmail="editaEmail"
      @cancelaEditaTelefone="cancelaEditaTelefone"
      @cancelaEditaEmail="cancelaEditaEmail"
      @addNewEndereco="addNewEndereco"
      @deleteEndereco="deleteEndereco"
      @deleteTelefone="deleteTelefone"
      @deleteEmail="deleteEmail"
      @changeEndereco="changeEndereco"
      @abreModalInfoProjeto="abreModalInfoProjeto"
     />
     <!-- Modal Info Projeto -->
     <ModalInfoProjeto 
      v-model="modalInfoProjeto"
      :projeto="projeto"
     />
  </div>
</template>

<script>
import Cliente from '@/domain/cliente/Cliente';
import ClienteEndereco from '@/domain/cliente/ClienteEndereco';
import ClienteTelefone from '@/domain/cliente/ClienteTelefone';
import ClienteEmail from '@/domain/cliente/ClienteEmail';
import ModalCadastroCliente from '@/components/cliente/ModalCadastroCliente';
import ModalInfoProjeto from '@/components/projeto/ModalInfoProjeto';
import Projeto from '@/domain/projeto/Projeto';
import { mapActions, mapMutations } from 'vuex';

export default {
  props: ["pageTitle", "cliente"],
  name: "InfoCliente",
  components: {
    ModalCadastroCliente,
    ModalInfoProjeto
  },
  data: () => ({
    showSearch: false,
    loading: false,
    modalCliente: false,
    clienteInfo: new Cliente(),
    clienteEndereco: new ClienteEndereco(),
    clienteTelefone: new ClienteTelefone(),
    clienteEmail: new ClienteEmail(),
    // Modal Info Projeto
    modalInfoProjeto: false,
    projeto: new Projeto()
  }),
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'fetchClienteById',
      'deleteCliente',
      'deleteClienteEndereco',
      'deleteClienteTelefone',
      'deleteClienteEmail',
      'fetchClienteEnderecos',
      'fetchClienteTelefones',
      'fetchClienteEmails',
      'fetchClienteTags',
      'fetchClienteProjetos',
      'fetchProjetoById',
      'fetchItensProjetosNode',
    ]),
    statusCliente(status) {
      status = status.trim();
      if (status == 'A') return 'Ativo';
      if (status == 'I') return 'Inativo';
      if (status == 'C') return 'Excluído';
    },
    corStatusCliente(status) {
      status = status.trim();
      if (status == 'A') return 'success';
      if (status == 'I') return 'grey';
      if (status == 'C') return 'error';
    },
    addNewEndereco() {
      this.clienteEndereco = Object.assign({}, new ClienteEndereco());
    },
    async deleteEmail(email) {
      if (confirm(`Desejar remover o email: ${email.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteEmail(email);
          this.loading = false;
          this.clienteEmail = Object.assign({}, new ClienteEmail());
          this.showNotification({ text: 'E-mail excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o e-mail: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async deleteTelefone(telefone) {
      if (confirm(`Desejar remover o telefone: ${telefone.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteTelefone(telefone);
          this.loading = false;
          this.clienteTelefone = Object.assign({}, new ClienteTelefone());
          this.showNotification({ text: 'Telefone excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o telefone: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async deleteEndereco() {
      if (this.clienteEndereco.IdCliente && this.clienteEndereco.IdItem && confirm(`Desejar excluir o endereço: ${this.clienteEndereco.Titulo}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteEndereco(this.clienteEndereco);
          this.loading = false;
          this.clienteEndereco = Object.assign({}, new ClienteEndereco());
          this.showNotification({ text: 'Endereço excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o endereço atual: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    changeEndereco(endereco) {
      this.clienteEndereco = Object.assign({}, endereco);
    },
    clienteAdicionado() {
      this.clienteInfo = Object.assign({}, new Cliente());
    },
    telefoneAdicionado() {
      this.clienteTelefone = Object.assign({}, new ClienteTelefone());
    },
    emailAdicionado() {
      this.clienteEmail = Object.assign({}, new ClienteEmail());
    },
    editaEmail(email) {
      this.clienteEmail = Object.assign({}, email);
      if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('G')) {
        this.clienteEmail.Tipo = 'GERAL';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('N')) {
        this.clienteEmail.Tipo = 'NFE';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('F')) {
        this.clienteEmail.Tipo = 'FINANCEIRO';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('C')) {
        this.clienteEmail.Tipo = 'COMERCIAL';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('O')) {
        this.clienteEmail.Tipo = 'OUTROS';
      } else {
        this.clienteEmail.Tipo = 'GERAL';
      }
    },
    cancelaEditaEmail() {
      this.clienteEmail = Object.assign({}, new ClienteEmail());
    },
    editaTelefone(telefone) {
      this.clienteTelefone = Object.assign({}, telefone);
      if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('G')) {
        this.clienteTelefone.TipoTelefone = 'GERAL';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('R')) {
        this.clienteTelefone.TipoTelefone = 'RESIDENCIAL';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('C')) {
        this.clienteTelefone.TipoTelefone = 'CELULAR';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('T')) {
        this.clienteTelefone.TipoTelefone = 'TRABALHO';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('W')) {
        this.clienteTelefone.TipoTelefone = 'WHATSAPP';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('O')) {
        this.clienteTelefone.TipoTelefone = 'OUTROS';
      } else {
        this.clienteTelefone.TipoTelefone = 'GERAL';
      }
    },
    cancelaEditaTelefone() {
      this.clienteTelefone = Object.assign({}, new ClienteTelefone());
    },
    async infoClient(cliente) {
      try {
        this.clienteInfo = Object.assign({}, cliente);
        this.modalCliente = true;
        const endereco = await this.fetchClienteEnderecos(cliente.IdCliente);
        this.clienteEndereco = Object.assign({}, endereco);
        await this.fetchClienteTelefones(cliente.IdCliente);
        await this.fetchClienteEmails(cliente.IdCliente);
        await this.fetchClienteTags(cliente.IdCliente);
        await this.fetchClienteProjetos(cliente.IdCliente);
      } catch (error) {
        this.showNotification({ text: `Ocorreu um erro ao buscar as informações do cliente: ${error}.`, status: 'error' });
      }
    },
    async abreModalInfoProjeto(projeto) {
      try {
        this.projeto = await this.fetchProjetoById({ id: projeto.IdProjeto });
        await this.fetchItensProjetosNode(projeto.IdProjeto);
        this.modalInfoProjeto = true;
      } catch (error) {
        this.showNotification({ text: `Ocorreu um erro ao buscar as informações do projeto: ${error}.`, status: 'error' });
      }
    }
  },
  computed: {
    iconSearch() {
      return this.showSearch ? 'clear' : 'search';
    }
  }
  
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.prewrap {
  white-space: pre-wrap;
}
</style>